/* eslint-disable react/prop-types */
import React from "react";
import TransitionGroup from "react-transition-group/TransitionGroup";
/**
 * @private
 */
export default function PanelGroup(_a) {
    var persistent = _a.persistent, disableTransition = _a.disableTransition, children = _a.children;
    if (persistent) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(TransitionGroup, { component: null, appear: !disableTransition, enter: !disableTransition, exit: !disableTransition }, children));
}
//# sourceMappingURL=PanelGroup.js.map